class AutoCompleteResult {

  /**
   * @param {Object} data
   * @param {string} data.address
   * @param {number} data.cityId
   * @param {number} data.countryId
   */
  constructor({address, cityId, countryId}) {
    /** @type {string} */
    this.address = address;
    /** @type {number} */
    this.cityId = cityId;
    /** @type {number} */
    this.countryId = countryId;
  }
}

export default AutoCompleteResult;